import { jwtDecode } from "jwt-decode";

export enum UserLevel {
  Admin = 0,
  Member = 1,
}

interface JwtPayload {
  level?: UserLevel;
  sub?: string;
  exp?: number;
  [key: string]: unknown;
}

export function decodeJwtPayload(token: string): JwtPayload | null {
  try {
    return jwtDecode<JwtPayload>(token);
  } catch {
    return null;
  }
}

export function getTokenLevel(token?: string): UserLevel | undefined {
  if (!token) return undefined;
  return decodeJwtPayload(token)?.level;
}
